// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] + "." + {"50":"6549fca6","133":"56bf70e3"}[chunkId] + ".chunk.js";
};